var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "operations-table" },
    [
      _c(
        "div",
        { staticClass: "operations-table-lg" },
        [
          _c(
            "scrolled-table",
            { attrs: { "fix-first": true, "fix-last": _vm.edit } },
            [
              _c("operations-table", {
                attrs: {
                  columns: _vm.columns,
                  dates: _vm.dates,
                  "sort-by": _vm.sortBy,
                  edit: _vm.edit,
                  "can-remove": _vm.canRemove,
                },
                on: {
                  sort: _vm.sort,
                  remove: _vm.remove,
                  restore: _vm.restore,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("operations-table-sm", {
        staticClass: "operations-table-sm",
        attrs: {
          columns: _vm.columns,
          dates: _vm.dates,
          "sort-by": _vm.sortBy,
          edit: _vm.edit,
          "can-remove": _vm.canRemove,
        },
        on: { sort: _vm.sort, remove: _vm.remove, restore: _vm.restore },
      }),
      _vm.dates.length === 0
        ? _c("div", { staticClass: "operations-table-empty" }, [
            _vm._v("Записи не найдены"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }